export default () => '/gas';
